import { useState } from "react";
import { StyledInput, StyledLabel, StyledText } from "./ToggleButton.styles";

export const ToggleButton = ({ label, toggled, onClick }: any) => {
  const [isToggled, toggle] = useState(toggled);

  const callback = () => {
    toggle(!isToggled);
    onClick(!isToggled);
  };

  return (
    <StyledLabel>
      <StyledInput type="checkbox" defaultChecked={isToggled} onClick={callback} />
      <span />
      <StyledText>{label}</StyledText>
    </StyledLabel>
  );
};
